<template>
  <div id="SectionSBTiPartner">
    <UIContainer class="SectionSBTiPartner__container">
      <template #left>
        <img
          class="SectionSBTiPartner__image"
          src="../assets/sbtiPartner/bg.avif"
          alt="SBTi validation partner"
          loading="lazy"
        />
      </template>

      <template #right>
        <div class="SectionSBTiPartner__content">
          <SectionTitle titleSize="sm">
            <template #title>
              Your end-to-end partner for SBTi validation
            </template>

            <template #description>
              From initial assessment to post-validation implementation, we
              provide the expertise and support you need to demonstrate your
              commitment to climate action with confidence.
            </template>
          </SectionTitle>

          <div class="SectionSBTiPartner__features">
            <div
              class="SectionSBTiPartner__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionSBTiPartner__feature-icon"
                name="checkCircle"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <div class="SectionSBTiPartner__cta">
            <UIButton size="xl" theme="primary" :to="{ name: 'Contact' }">
              Book a consultation
            </UIButton>
          </div>
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

const features = [
  'Science-based target setting (SBTi alignment)',
  'Decarbonization pathway modeling',
  'Action plan development and tracking',
  'Complete submission support',
  'Post-validation guidance',
]
</script>

<style lang="scss" scoped>
#SectionSBTiPartner {
  position: relative;
  background-color: $color-white;

  .SectionSBTiPartner__container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .SectionSBTiPartner__image {
    display: none;
    width: 100%;
    max-height: 32rem;
    border-radius: 1.5rem;

    @include md {
      display: block;
      right: 0;
    }
  }

  .SectionSBTiPartner__content {
    padding: 1rem 0;
    @include md {
      margin-left: 6rem;
    }
  }

  .SectionSBTiPartner__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionSBTiPartner__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionSBTiPartner__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionSBTiPartner__feature-icon {
    --size: 1.75rem;
  }

  .SectionSBTiPartner__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
